// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeView--Header {
  position: relative;
  z-index: 1;
  margin-top: -12rem;
  padding-top: 11rem;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  background-color: white;
  padding-inline: 1.5rem;
  min-height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
}
.HomeView--Header .HomeView--profileName {
  font-size: 2.5rem;
  margin: 1.5rem 1rem;
}
.HomeView--Header .HomeView--Card {
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;
}

.HomeView {
  margin-bottom: 0;
  height: 100%;
}

.HomeView--NavbarSpacer {
  height: 8rem;
}

@media screen and (max-width: 360px) {
  .responsive--homeView {
    margin-bottom: 0;
  }
  .responsive--header {
    margin-top: -10rem;
  }
}
.app-container {
  display: flex;
  justify-content: center;
  position: relative;
  bottom: 160px;
}

.floating-card {
  width: 70%;
  height: 100px;
  object-fit: cover;
  cursor: pointer;
  position: absolute;
  z-index: 10;
}

@media screen and (max-height: 750px) {
  .app-container {
    bottom: 110px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Views/AfterAuth/HomeView/HomeView.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,uBAAA;EACA,sBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;AAAJ;AAEI;EACI,iBAAA;EACA,mBAAA;AAAR;AAGI;EACI,aAAA;EACA,SAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;AADR;;AAKA;EACI,gBAAA;EACA,YAAA;AAFJ;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI;IACI,gBAAA;EAFN;EAKE;IACI,kBAAA;EAHN;AACF;AAMA;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;AAJJ;;AAOA;EACI,UAAA;EACA,aAAA;EAEA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AALJ;;AAOA;EACI;IACI,aAAA;EAJN;AACF","sourcesContent":["@import '../../../Styles/sass/variables';\n.HomeView--Header {\n    position: relative;\n    z-index: 1;\n    margin-top: -12rem;\n    padding-top: 11rem;\n    border-top-left-radius: 24px;\n    border-top-right-radius: 24px;\n    background-color: white;\n    padding-inline: 1.5rem;\n    min-height: calc(100vh - 200px);\n    display: flex;\n    flex-direction: column;\n\n    .HomeView--profileName {\n        font-size: 2.5rem;\n        margin: 1.5rem 1rem;\n    }\n\n    .HomeView--Card {\n        display: flex;\n        gap: 2rem;\n        justify-content: space-between;\n        margin-bottom: 1.5rem;\n        margin-top: 1.5rem;\n    }\n}\n\n.HomeView {\n    margin-bottom: 0;\n    height: 100%;\n}\n\n.HomeView--NavbarSpacer {\n    height: 8rem;\n}\n\n@media screen and (max-width: 360px) {\n    .responsive--homeView {\n        margin-bottom: 0;\n    }\n\n    .responsive--header {\n        margin-top: -10rem;\n    }\n}\n\n.app-container {\n    display: flex;\n    justify-content: center;\n    position: relative;\n    bottom: 160px;\n}\n\n.floating-card {\n    width: 70%;\n    height: 100px;\n\n    object-fit: cover;\n    cursor: pointer;\n    position: absolute;\n    z-index: 10;\n}\n@media screen and (max-height: 750px) {\n    .app-container {\n        bottom: 110px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
